import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Stack } from '@mui/material';
import { Add, ArrowBack } from '@mui/icons-material';
import { sxConfig } from './workspace.style';
import { AutoCompleteSelectUI, FormLabelUI } from '../../Interface';
import { WorkspacePage } from './WorkspacePage';
import OverviewPage from './OverviewPage';
import { useWorkspace } from '../../../hooks/useWorkspace';
import CreateWorkspaceDialog from './CreateWorkspaceDialog/CreateWorkspaceDialog';

export const WorkspaceMain = () => {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const workspaceState = useWorkspace();
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [createWorkspaceDialog, setCreateWorkspaceDialog] = useState({
    open: false,
    companyId: null,
  });

  useEffect(() => {
    if (projectId && !workspaceState.isLoading) setSelectedProjectId(parseInt(projectId));
  }, [projectId, workspaceState.isLoading]);

  const handleProjectChange = (newProjectId = null) => {
    setSelectedProjectId(newProjectId);

    if (projectId) {
      navigate('/app/workspace', { replace: true });
    }
  };

  return (
    <>
      <Box sx={sxConfig.page}>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={2} mb={2} position="relative">
          {selectedProjectId && (
            <Button
              variant="outlined"
              startIcon={<ArrowBack />}
              onClick={() => handleProjectChange()}
              sx={{ position: 'absolute', left: 0 }}
            >
              Vissza
            </Button>
          )}
          <Box width={400}>
            <AutoCompleteSelectUI
              label={<FormLabelUI text="Keresés" />}
              variant="outlined"
              size="small"
              dataset={workspaceState.autoCompleteOptions.project}
              selectedValue={selectedProjectId}
              onChange={(_e, newVal) => handleProjectChange(newVal?.value)}
            />
          </Box>
        </Stack>
        {!selectedProjectId && (
          <Box mb={2}>
            <Button variant="contained" startIcon={<Add />} onClick={() => setCreateWorkspaceDialog({ open: true })}>
              Új adatlap
            </Button>
          </Box>
        )}
        {selectedProjectId ? (
          <WorkspacePage
            workspaceState={workspaceState}
            selectedProjectId={selectedProjectId}
            setCreateWorkspaceDialog={setCreateWorkspaceDialog}
          />
        ) : (
          <OverviewPage setSelectedProjectId={setSelectedProjectId} workspaceState={workspaceState} />
        )}
      </Box>
      <CreateWorkspaceDialog
        dialogData={createWorkspaceDialog}
        handleClose={() => setCreateWorkspaceDialog({ open: false, companyId: null })}
        workspaceState={workspaceState}
        setSelectedProjectId={setSelectedProjectId}
      />
    </>
  );
};
